import * as React from "react";

import { useSelector, useDispatch } from "../../../../store";
import { toggleModuleBreak } from "../../../../store/slices/learner";
import { Box } from "@mui/material";

import FinishQuizDialog from "./FinishLaterDialog";
import { moduleLables, quizData } from "../../../../constants";

export default function WebModuleBreak({
    onChangeWebStyleLayout = () => {}
}) {
	const learner = useSelector((state) => state.learner || {});
	const dispatch = useDispatch();

    const skillImage = quizData.acsf4.icons.skills;

    React.useEffect(() => {
        onChangeWebStyleLayout({
            style: {
                backgroundColor: "#148e8e",
                borderBottom: "60px solid #016d7c",
                hideFooter: true,
            }
        });
    }, [onChangeWebStyleLayout]);

	const handleContinue = async () => {
		await dispatch(toggleModuleBreak());
	};
	return (
		<React.Fragment>
            <Box sx={{
                textAlign: "center"
            }}>
                <h1 style={{
                        textAlign: "center",
                        fontSize: "4em",
                        marginTop: "10px",
                        marginBottom: "10px",
                    }}>Well Done</h1>

                    <Box sx={{
                        textAlign: "center",
                        fontSize: "2.25em",
                        marginTop: "10px",
                        marginBottom: "10px",
                    }}>
                        <p style={{
                                margin: "0",
                                textAlign: "center",
                            }}
                        >You have finished the{" "}
                        <b>{moduleLables[learner?.modules?.previous] || ""}</b>{" "}
                        Questions.</p>
                        <p style={{
                                margin: "0",
                                textAlign: "center",
                            }}
                        >Continue to{" "}
                        <b>{moduleLables[learner?.modules?.new] || ""}</b>{" "}
                        Questions.</p>
                    </Box>

                    <Box sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}>
                        <Box component="img" 
                            src={skillImage[learner?.modules?.previous]} 
                            sx={{
                                flexGrow: "0",
                                flexShrink: "0",
                                maxWidth: "100%",
                                height: "auto",
                                margin: "0 20px",
                            }}
                            alt="Module Previous Img"
                        />
                        <img src="data:image/png;base64,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" 
                            style={{
                                flexGrow: "0",
                                flexShrink: "0",
                            }}
                            alt="Next Icon Img"
                        />
                        <Box component="img" 
                            src={skillImage[learner?.modules?.new]} 
                            sx={{
                                flexGrow: "0",
                                flexShrink: "0",
                                maxWidth: "100%",
                                height: "auto",
                                margin: "0 20px",
                            }}
                            alt="Module Next Img"
                        />
                    </Box>
            </Box>
            <Box sx={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                textAlign: "center",
            }}>
                <FinishQuizDialog 
                    buttonStyle={{
                        marginTop: "12px",
                        p: "10px 25px",
                        width: "185px",
                        height: "44px",
                        fontSize: "1.45rem",
                        backgroundColor: "#FF3300",
                        borderRadius: "5px",
                        borderBottom: "2px solid #FF3300",
                        boxShadow: "none",
                        "&:hover": {
                            backgroundColor: "#FF3300",
                            borderBottom: "2px solid #FF3300",
                            cursor: "pointer",
                            boxShadow: "none",
                        },
                        fontWeight: "bold",
                        fontFamily: "'Arimo',sans-serif",
                    }}
                    title="Finish Later"
                />

                <button
                    style={{
                        fontSize: ".8rem",
                        marginTop: "8px",
                        cursor: "pointer",
                        display: "inline-block",
                        width: "230px",
                        height: "45px",
                        backgroundColor: "#0e9595",
                        color: "white",
                        border: "none",
                        borderRadius: "5px",
                        borderBottom: "2px solid #0e9595",
                        textDecoration: "none",
                        boxSizing: "border-box",
                        paddingTop: "3px",
                        textAlign: "center",
                        "&:hover": {
                            backgroundColor: "none",
                            cursor: "pointer",
                        },
                    }}
                    onClick={() => handleContinue()}
                >
                    <Box component="span"
						sx={{
                        fontWeight: "bold",
                        fontSize: "2em",
                        color: "white",
                        textAlign: "center",
                    }}>Continue Quiz</Box>
                </button>

            </Box>
		</React.Fragment>
	);
}